import videojs from 'video.js';
import './swiper-bundle.min.css';
import Swiper from './swiper-bundle.min';
import { getSlideHtml } from './get-slide-html';

const Component = videojs.getComponent('Component');

const defaultOptions = {};

export default class StreamShoppingSlider extends Component {
  constructor(player, options) {
    super(player, options);
    this.player = player;
    this.options = videojs.mergeOptions(defaultOptions, options);

    this.productEl = this.el().querySelector('.swiper-wrapper');
    this.setListeners();
    if (!this.products || this.products.length == 0) {
      this.hide();
    } else {
      this.renderProducts();
      if (this.currentProductId) {
        this.player.one('ready', () => this.slideToProductCard(this.currentProductId));
      }
    }
  }

  get products() {
    return this.options_.products || [];
  }

  get currentProductId() {
    return this.options_.currentProductId;
  }

  slideToProductCard(productCardId) {
    let index = this.products.findIndex(e => e.id == productCardId);
    this.swiper.slideTo(index);
  }

  setListeners() {
    // Обновляет отступ снизу у слайдера в соответствии с изменением высоты поля для ввода комментария
    setTimeout(() => {
      const chatMessangerComponent = this.player.getChild('ChatMessanger');
      if (!chatMessangerComponent) return;
      chatMessangerComponent.on('ChatMessanger/resizeTextarea', (event) => {
        if (this.player.el_.dataset.viewMode === 'mobile') {
          this.el().style.setProperty('--slider-additional-height', event.payload);
        }
      });
    });

    this.player.one('ready', () => {
      this.swiper = new Swiper(
        this.el().querySelector('.vjs-stream-shopping-slider__conainer-slider'),
        {
          breakpointsBase: 'container',
          width: 240,
          spaceBetween: 6,
          navigation: {
            nextEl: '.vjs-stream-shopping-slider__conainer-slider .swiper-button-next',
            prevEl: '.vjs-stream-shopping-slider__conainer-slider .swiper-button-prev',
          },
        }
      );
      window.addEventListener('resize', this.updateWidth.bind(this));
      this.updateWidth();

      const buttonToggle = this.player.getChild('controlBar').getChild('ButtonToggleStreamShopping');
      if (buttonToggle) {
        buttonToggle.on('StreamShopping/visible', this.updateWidth.bind(this));
      }
    });

    this.el()
      .querySelector('.vjs-stream-shopping-slider__conainer-slider')
      .addEventListener('click', (event) => {
        if (event.target.classList.contains('vjs-stream-shopping-slider__buy')) return;
        let slideEl = event.target;
        while(!slideEl.classList.contains('vjs-stream-shopping-slider__slide')) {
          if (slideEl === event.currentTarget) return;
          slideEl = slideEl.parentElement;
        }
        if (slideEl) {
          const productId = slideEl.dataset.productId;
          const product = this.options.products[productId];
          if (product === undefined) return;
          const listProductsComponent = this.player.getChild('ListProducts');
          listProductsComponent.setProductsViewMode('detail', product);
          listProductsComponent.toggleVisibility();
        }
      });
  }

  updateWidth() {
    if (this.player.el_.dataset.viewMode === 'mobile') {
      const chatMessanger = this.player.getChild('ChatMessanger');
      if (!chatMessanger) return;
      const isFullWidth = [ ...this.player.el().classList ].some((className) => className.startsWith('vjs-size-w'));
      if (isFullWidth) {
        this.el().style.width = '';
      } else {
        const chatMessangerWidth = chatMessanger.el().clientWidth;
        const _chatMessangerWidth = chatMessanger.currentWidth()
        let extraIndent = 10;
        const likesComponent = this.player.getChild('Likes');
        if (likesComponent) {
          const chatMessangerComponent = this.player.getChild('ChatMessanger');
          if (chatMessangerComponent && chatMessangerComponent.checkVisibility() === false) {
            const spanFromLikes = 10;
            extraIndent += likesComponent.currentWidth() + spanFromLikes;
          }
        }
        this.el().style.width = `calc(100% - ${ chatMessangerWidth + extraIndent }px)`;
      }
    }
  }

  updateBottomPosition() {
    if (this.player.el_.dataset.viewMode !== 'mobile') return;

    const chatMessanger = this.player.getChild('ChatMessanger');
    if (!chatMessanger) return;

    const chatMessangerReplyEl = chatMessanger.el().querySelector('.vjs-chat-form-reply');
    const chatMessangerAttachmentsEl = chatMessanger.el().querySelector('.vjs-chat-form-body__attached-files');

    if (!chatMessangerReplyEl && !chatMessangerAttachmentsEl) {
      this.el().style.removeProperty('--chat-messanger-form-el-height');
    } else {
      const chatMessangerReplyHeight = chatMessangerReplyEl ? chatMessangerReplyEl.offsetHeight : 0;
      const chatMessangerAttachmentsHeight = chatMessangerAttachmentsEl ? chatMessangerAttachmentsEl.offsetHeight : 0;

      const sliderOffsetHeight = chatMessangerReplyHeight + chatMessangerAttachmentsHeight;
      this.el().style.setProperty('--chat-messanger-form-el-height', `${sliderOffsetHeight}px`);
    }
  }

  createEl() {
    const el = videojs.createEl('div', {
      className: 'vjs-stream-shopping-slider',
    });
    el.insertAdjacentHTML('afterbegin', this.getContainterHtml());
    return el;
  }

  renderProducts() {
    this.products.forEach((product, index) => this.addProductToSlider(product, index));
  }

  addProductToSlider(product, id) {
    this.productEl.insertAdjacentHTML('beforeend', getSlideHtml(product, id, 'swiper-slide'));
  }

  getContainterHtml() {
    return `
    <div class="vjs-stream-shopping-slider__conainer-slider">
      <div class="swiper-wrapper"></div>

      <!-- If we need navigation buttons -->
      <div class="swiper-button-prev"></div>
      <div class="swiper-button-next"></div>
    </div>`;
  }
}

Component.registerComponent('StreamShoppingSlider', StreamShoppingSlider);
